// @ts-nocheck

import { fetchAddresses, fetchProducts, postOrder } from '@/api/onboardingAPI'

import { initialState } from '../onboardingReducer'

import { STEP_WORK_TYPE } from './constants'
import { getOrder, getPostageProductFromZip } from './onboardingSelectors'

export const WORK_TYPE_OFFICE = 'WORK_TYPE_OFFICE'
export const WORK_TYPE_PROFESSIONAL = 'WORK_TYPE_PROFESSIONAL'

export const NAME_SPACE = 'ONBOARDING'

export const RESET = `${NAME_SPACE}/RESET`
export const RESET_ALL_ACCESSORIES = `${NAME_SPACE}/RESET_ALL_ACCESSORIES`

export const INCREASE_STEP = `${NAME_SPACE}/INCREASE_STEP`
export const DECREASE_STEP = `${NAME_SPACE}/DECREASE_STEP`
export const GO_TO_STEP = `${NAME_SPACE}/GO_TO_STEP`
export const HIDE_MONITOR_STEP_SPLASH = `${NAME_SPACE}/HIDE_MONITOR_STEP_SPLASH`
export const HIDE_ACCESORY_STEP_SPLASH = `${NAME_SPACE}/HIDE_ACCESORY_STEP_SPLASH`

export const SET_WORK_TYPE = `${NAME_SPACE}/SET_WORK_TYPE`

export const SET_SELECTED_MACHINE = `${NAME_SPACE}/SET_SELECTED_MACHINE`
export const SET_SELECTED_IMAGE = `${NAME_SPACE}/SET_SELECTED_IMAGE`

export const SET_SELECTED_SCREEN = `${NAME_SPACE}/SET_SELECTED_SCREEN`

export const TOGGLE_PRODUCT = `${NAME_SPACE}/TOGGLE_PRODUCT`

export const SET_ADDRESS_ID = `${NAME_SPACE}/SET_ADDRESS_ID`

export const LOAD_PRODUCTS_INIT = `${NAME_SPACE}/LOAD_PRODUCTS_INIT`
export const LOAD_PRODUCTS_SUCCESS = `${NAME_SPACE}/LOAD_PRODUCTS_SUCCESS`
export const LOAD_PRODUCTS_FAILURE = `${NAME_SPACE}/LOAD_PRODUCTS_FAILURE`

export const LOAD_ADDRESSES_INIT = `${NAME_SPACE}/LOAD_ADDRESSES_INIT`
export const LOAD_ADDRESSES_SUCCESS = `${NAME_SPACE}/LOAD_ADDRESSES_SUCCESS`
export const LOAD_ADDRESSES_FAILURE = `${NAME_SPACE}/LOAD_ADDRESSES_FAILURE`

export const POST_ORDER_PENDING = `${NAME_SPACE}/POST_ORDER_PENDING`
export const POST_ORDER_SUCCESS = `${NAME_SPACE}/POST_ORDER_SUCCESS`
export const POST_ORDER_FAILURE = `${NAME_SPACE}/POST_ORDER_FAILURE`

export const HIDE_INITIAL_SPLASH = `${NAME_SPACE}/HIDE_INITIAL_SPLASH`
export const SHOW_INITIAL_SPLASH_MNGR = `${NAME_SPACE}/SHOW_INITIAL_SPLASH_MNGR`

export const scrollToTop = () => {
  const elm = document.querySelector('.onboarding')
  if (elm) {
    elm.scrollTop = 0
  }
}

export const goToOnboarding =
  (navigate, step = STEP_WORK_TYPE) =>
  dispatch => {
    dispatch(goToStep(step))
    navigate('/onboarding')
    scrollToTop()
  }

export const resetOrder = () => {
  scrollToTop()
  return {
    type: RESET,
  }
}

export const resetAllProducts = () => ({
  type: RESET_ALL_ACCESSORIES,
})

export const increaseStep = () => increaseStepBy(1)

export const increaseStepBy = (stepIncrease = 1) => {
  scrollToTop()
  return {
    type: INCREASE_STEP,
    stepIncrease,
  }
}

export const decreaseStep = () => {
  scrollToTop()
  return {
    type: DECREASE_STEP,
  }
}

export const goToStep = step => {
  scrollToTop()
  return {
    type: GO_TO_STEP,
    step,
  }
}

export const setWorkType = workType => dispatch => {
  dispatch({
    type: SET_WORK_TYPE,
    workType,
  })
  dispatch({
    type: SET_SELECTED_IMAGE,
  })
  dispatch(increaseStep())
}

export const hideMonitorSplash = () => {
  scrollToTop()
  return {
    type: HIDE_MONITOR_STEP_SPLASH,
  }
}

export const hideAccessorySplash = () => {
  scrollToTop()
  return {
    type: HIDE_ACCESORY_STEP_SPLASH,
  }
}

export const hideInitialSplash = () => {
  scrollToTop()
  return {
    type: HIDE_INITIAL_SPLASH,
  }
}
export const showInitialSplashMngr = () => {
  scrollToTop()
  return {
    type: SHOW_INITIAL_SPLASH_MNGR,
  }
}

const loadProductsStart = () => ({
  type: LOAD_PRODUCTS_INIT,
})

const loadProductsFailure = error => ({
  type: LOAD_PRODUCTS_FAILURE,
  error,
})

const loadProductsSuccess = products => ({
  type: LOAD_PRODUCTS_SUCCESS,
  products,
})

export const selectMachine = pid => dispatch => {
  scrollToTop()
  dispatch({
    type: SET_SELECTED_MACHINE,
    pid,
  })
  dispatch(resetAllProducts())
  dispatch(increaseStep())
  // Automatically add docking to order
  // getDockings(getState()).forEach(product =>
  //     dispatch(toggleProduct(product.id))
  // );
}

export const selectMachineImage = pid => dispatch => {
  scrollToTop()
  dispatch({
    type: SET_SELECTED_IMAGE,
    pid,
  })
  if (pid !== initialState.selectedImageId) {
    // dispatch(increaseStep());
  }
}

export const setScreen =
  (pid, double = false) =>
  dispatch => {
    dispatch({
      type: SET_SELECTED_SCREEN,
      pid,
      double,
    })
    if (pid !== initialState.selectedImageId) {
      // dispatch(increaseStep());
    }
  }

export const toggleProduct = pid => ({
  type: TOGGLE_PRODUCT,
  pid,
})

export const setAddressId =
  ({ addressId, addressList }) =>
  (dispatch, getState) => {
    const adr = addressList.find(addressListItem => addressListItem.id === addressId)
    const pid = getPostageProductFromZip(getState(), adr.zip).id

    dispatch({
      type: SET_ADDRESS_ID,
      aid: addressId,
      pid,
    })
  }

// TODO: Remove this at an appropriate time.
// const multiConsultText = 'NB! HP har for øyeblikket store leveranseproblemer på alle type PCer, skjermer og tilbehør. Leveringstiden er derfor lengere enn normalt. 2-3 uker må påregnes.\n\nNyansatte vil bli prioritert først. Ta kontakt med helpdesk@multiconsult.no';

export const loadProducts = () => dispatch => {
  dispatch(loadProductsStart())

  fetchProducts()
    .then(products => {
      dispatch(loadProductsSuccess(products))
      // dispatch(addMessage('Søk om PC og tilbehør', multiConsultText,true)); // TODO: Remove this at an appropriate time.
    })
    .catch(error => {
      dispatch(loadProductsFailure(error))
    })
  fetchAddresses()
    .then(addresses =>
      dispatch({
        type: LOAD_ADDRESSES_SUCCESS,
        addresses,
      })
    )
    .catch(error => {
      dispatch(loadProductsFailure(error))
    })
}

export const submitOrder = costObjectId => (dispatch, getState) => {
  dispatch({
    type: POST_ORDER_PENDING,
  })

  const order = getOrder(getState(), costObjectId)

  postOrder(order)
    .then(order => {
      dispatch({
        type: POST_ORDER_SUCCESS,
        order,
      })
      dispatch(increaseStep())
    })
    .catch(error => {
      dispatch({
        type: POST_ORDER_FAILURE,
        error,
      })
    })
}
